export default "__VITE_ASSET__CHGR22p9__"